<template>
    <!--mob overlay-->
    <div class="flex flex-column fixed surface-100 w-full h-full z-5" v-if="mob_menu">
        <div class="flex w-full">
            <div class="header w-full flex surface-0" >
                <div class="center flex w-full pl-3 pr-3 xl:pl-4 xl:pr-4">
                    <div class="header_left flex flex-1">
                        <!--logo-->
                        <div class="flex indigo-container cursor-pointer mr-4 max-w-8rem" @click="go_home(); mob_menu=false">
                            <div class="flex align-items-center justify-content-center w-full">
                                <Avatar size="large" image="/images/svg/pay-wave-new-logo.svg" class="logo border-round-lg overflow-hidden w-full m-0" />
                            </div>
                        </div>
                    </div>
                    <div class="header_right flex flex-initial justify-content-right align-items-center">
                        <!--color mode-->
                        <Button rounded severity="secondary" variant="text" class="flex uppercase text-700"
                            @click="changeColorMode" :icon="themeMode ? 'pi pi-sun' : 'pi pi-moon'"/>
                        <!--lang-->
                        <Button :label="local" icon="pi pi-angle-down" @click="toggle_menu_lang" class="flex uppercase text-700 ml-2" variant="text" severity="secondary" iconPos="right" rounded/>
                        <Menu ref="menu_lang" :model="locals" :popup="true" class="header_menu_lang">
                            <template #item="{ item }">
                                <span class="langItem p-menuitem-link" @click="change_lang(item.code)"
                                :class="{'active-link-exact': (item.code==lang_) ? true : false }">
                                    <span class="p-menuitem-text">{{ item.label }}</span>
                                </span>
                            </template> 
                        </Menu>
                        <!--menu-->
                        <Button v-if="(screen_size=='xs' || screen_size=='sm')" :label="buttons[lang_].menu" class="flex text-700 ml-2" @click="show_mob_menu()" icon="pi pi-times" variant="text" severity="secondary" iconPos="right" rounded />
                    </div>
                </div>
            </div>
        </div>
        <div class="flex w-full border-noround relative p-4 flex-column overflow-scroll pb-8">
            <MobMenu :items="formatedMenu" class="w-full mt-3 mb-3" @go="mob_menu=false" />

            <MobMenu :items=[] :headerTxt="(!isLoggedIn) ? buttons[lang_].retText : ''">
                <template v-slot:body>

                    <!--REG-->
                    <div v-if="!isLoggedIn" @click="go_reg()"
                        class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-at" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ buttons[lang_].registration }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>

                    <!--SIGNIN-->
                    <div v-if="!isLoggedIn" @click="go_login()"
                        class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-sign-in" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ buttons[lang_].sign_in }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>

                    <!--LOGUOT-->
                    <div v-if="isLoggedIn" @click="logout()"
                        class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-sign-out" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">{{ buttons[lang_].exit }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2 pi pi-angle-right" />
                        </div>
                    </div>

                </template>
            </MobMenu>
        </div>
    </div>

    <!--header-->
    <div v-if="!hideHeader" class="flex-none z-2 w-full fixed border-bottom-2 border-100">
        <div class="header w-full flex surface-0" >
            <div class="center flex w-full pl-3 pr-3 xl:pl-4 xl:pr-4">
                <div class="header_left flex flex-1">
                    <!--logo-->
                    <div class="flex indigo-container cursor-pointer mr-0 xl:m-r4 lg:mr-3 md:mr-3 sm:mr-2 max-w-8rem" @click="go_home()">
                        <div class="flex align-items-center justify-content-center w-full">
                            <Avatar size="large" image="/images/svg/pay-wave-new-logo.svg" class="logo border-round-lg overflow-hidden w-full m-0" />
                        </div>
                    </div>
                    <!--top menu-->
                    <div class="w-full align-items-center justify-content-start overflow-hidden hidden xl:flex lg:flex md:flex">
                        <Menubar :model="menuTop" id="header" v-if="!pageMode" class="hidden xl:flex lg:flex md:flex flex-initial header_menu border-none">
                            <template #item="{ item }">
                                <router-link :to="item.to" custom v-slot="{ href, route, navigate, isActive, isExactActive }">
                                    <div v-if="!item.items"
                                        :class="{ 'active-link-exact': isExactActive, 'text-900': !isExactActive, 'text-600': isExactActive}"
                                        class="p-menuitem-link flex" >
                                        <a :href="href" @click="navigate"
                                            :class="{ 'active-link-exact': isExactActive, 'text-900': !isExactActive, 'text-600': isExactActive}"
                                            style="padding-top:0.65rem!important;padding-bottom:0.65rem!important;"
                                            class="flex flex-1 p-2 no-underline cursor-pointer" >
                                            {{ item.label }}
                                        </a>
                                        <span v-if="item.isNewTab" @click="goTo(item.to)"
                                            style="padding-top:0.65rem!important;padding-bottom:0.65rem!important;"
                                            class="flex pi pi-external-link p-2 text-500 text-xs cursor-pointer hover:text-primary"></span>
                                    </div>
                                    <a v-else 
                                        :class="{ 'active-link-exact': isExactActive, 'text-900': !isExactActive, 'text-600': isExactActive}"
                                        style="padding-top:0.65rem!important;padding-bottom:0.65rem!important;"
                                        class="p-menuitem-link p-2 flex no-underline cursor-pointer" >
                                        {{ item.label }}
                                        <i class="pi pi-angle-down ml-2"></i>
                                    </a>
                                </router-link>
                            </template>
                        </Menubar>
                    </div>
                </div>
                <div class="header_right flex flex-initial justify-content-right align-items-center">

                    <!--color mode-->
                    <Button rounded severity="secondary" variant="text" class="hidden xl:flex lg:flex md:flex sm:flex uppercase text-700"
                        @click="changeColorMode" :icon="themeMode ? 'pi pi-sun' : 'pi pi-moon'"/>

                    <!--lang-->
                    <Button :label="local" icon="pi pi-angle-down" iconPos="right" @click="toggle_menu_lang" class="hidden xl:flex lg:flex md:flex md:flex uppercase ml-2 text-700" rounded severity="secondary" variant="text"/>
                    <Menu ref="menu_lang" :model="locals" :popup="true" class="header_menu_lang">
                        <template #item="{ item }">
                            <span class="langItem p-menuitem-link p-2 flex no-underline cursor-pointer border-round-md" @click="change_lang(item.code)"
                                :class="{'active-link-exact': (item.code==lang_) ? true : false }">
                                <span class="p-menuitem-text border-round-md">{{ item.label }}</span>
                            </span>
                        </template> 
                    </Menu>
                    
                    <!--profile-->
                    <Button v-if="isLoggedIn && (screen_size!='xs' && screen_size!='sm')" class="flex ml-2 pl-0 pr-3 text-700" @click="toggle_menu" severity="secondary" variant="text" rounded>
                        <Avatar v-if="user_photo" :image="user_photo" size="medium" class="ml-2 header_avatar" shape="circle" />
                        <Avatar v-else size="medium" :label="(user_letter) ? user_letter : 'U'" class="ml-2 header_avatar" shape="circle" />
                        <i class="pi pi-angle-down"></i>
                    </Button>
                    <div class="flex" v-if="isLoggedIn && (screen_size=='xs' || screen_size=='sm')">
                        <Avatar v-if="user_photo" :image="user_photo" @click="toProfile()" size="medium" class="ml-2 header_avatar cursor-pointer" shape="circle" />
                        <Avatar v-else size="medium" :label="(user_letter) ? user_letter : 'U'" @click="toProfile()" class="ml-2 header_avatar cursor-pointer" shape="circle" />
                    </div>
                    <Menu ref="menu" :model="menuPersonal" :popup="true" class="header_menu_profile">
                        <template #start>
                            <div v-if="isLoggedIn" class="px-3 py-2 border-bottom-1 border-black-alpha-10">
                                {{ (user_name) ? user_name : '' }}<br>
                                ({{ (user_login) ? user_login : '' }})
                            </div>
                        </template>
                        <template #item="{ item }">
                            <router-link :to="item.to" :icon="item.icon" custom
                                v-slot="{ href, route, navigate, isActive, isExactActive }">
                                <a :href="href" :visible="item.visible" @click="navigate" class="p-menuitem-link p-2 flex no-underline cursor-pointer border-round-md text-900"
                                    :class="{ 'active-link': isActive, 'router-link-active': isExactActive, 'p-menuitem-link': true, 'pr-4': true }">
                                    <span class="p-menuitem-text">{{ item.label }}</span>
                                    <span :class="{ 'p-menuitem-icon': true }" class="ml-2">
                                        <i v-if="item.name=='Profile'" class="pi pi-user" />
                                        <i v-if="item.name=='Logout'" class="pi pi-sign-out" />
                                    </span>
                                </a>
                            </router-link>
                        </template>
                    </Menu>

                    <!--buttons-->
                    <Button v-if="!isLoggedIn"  :label="buttons[lang_].registration" class="hidden xl:flex ml-2 align-items-center" @click="go_reg()" rounded/>
                    <Button v-if="!isLoggedIn"  :label="buttons[lang_].sign_in" class="flex ml-2 text-700" @click="go_login()" variant="text" severity="secondary" rounded/>
                    <Button v-if="(screen_size=='xs' || screen_size=='sm')" :label="buttons[lang_].menu" class="flex ml-2 text-700" @click="show_mob_menu()" icon="pi pi-bars" variant="text" severity="secondary" iconPos="right" rounded />
                </div>
            </div>
        </div>
    </div>
    <div class="block" style="height:70px" :class="(hideHeader) ? 'surface-200' : ''"></div>
</template>


<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Event from '@/assets/js/Event'
import MobMenu from '@/components/sides/menu/MobMenu.vue'

export default {
    name: 'Header',
    props: ['menuTop', 'menuPersonal', 'menuMob'],
    data() {
        return {
            buttons:  {
                en:{
                    registration : "Registration",
                    retText: "To register you only need an email and phone number",
                    sign_in: "Sign In",
                    exit: "Log Out",
                    menu: "Menu",
                },
                ru:{
                    registration : "Регистрация",
                    retText: "Для регистрации нужна только почта и номер телефона",
                    sign_in: "Войти",
                    exit: "Выйти",
                    menu: "Меню",
                }                 
            }, 
            locals: [
                { code: 'en', label: 'EN' },
                { code: 'ru', label: 'RU' }
            ],
            local: (this.$store.getters.StateLang) ? this.$store.getters.StateLang : (this.$i18n.locale) ? this.$i18n.locale : 'en',
            mob_menu: false,
            themeMode: false,
            formaredMenu: [],
        }
    },
    components: {
        MobMenu
    },
    methods: {
        goTo(path) {
            const routeData = this.$router.resolve({path});
            window.open(routeData.href, '_blank');
        },
        go_home() {
            this.$router.push('/')
        },
        go_reg() {
            this.$router.push({ path: '/reg/' })
            this.mob_menu=false
            this.event.send('regBtn')
        },
        go_login() {
            this.$router.push({ path: '/auth/' })
            this.mob_menu=false
            this.event.send('loginBtn')
        },
        toProfile() {
            this.$router.push({ path: '/personal/profile/' })
            this.mob_menu=false
        },
        async change_lang(lang) {
            this.$i18n.locale = lang
            this.local = lang
            this.event.send('changeLang')
            try{
                await this.$store.dispatch('SetLang', lang).then(() => {})
            } catch {
                console.log('error store lang')
            }
        },
        toggle_menu(event) {
            this.$refs.menu.toggle(event);
        },
        toggle_menu_lang(event) {
            this.$refs.menu_lang.toggle(event);
        },
        show_mob_menu() {
            this.mob_menu = !this.mob_menu
        },
        logout(){
            this.mob_menu=false
            this.event.send('logoutBtn')
            this.$store.dispatch('LogOut')
            this.$router.push({path: '/'})
        },
        changeColorMode(){
            const mode = this.isDarkTheme
            this.themeMode = !this.themeMode
            this.$store.dispatch('SetDarkTheme', !mode)
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        user_letter: function () { return this.$store.getters.StateLetter },
        user_photo: function () { return this.$store.getters.StateUserPhoto },
        user_name: function () { return this.$store.getters.StateUserName },
        user_login: function () { return this.$store.getters.StateUserLogin },
        userGroups: function () { return this.$store.getters.StateGroups },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        pageMode: function () {
            try {
                return this.$route.meta.pageMode
            } catch {
                return false
            }
        },
        hideHeader: function () {
            if(this.$route.name=='Transfer Details' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='AdmTransferDetail' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Bill' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Deal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='PersonalDeal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            return false
        },
        formatedMenu() {
            if(!this.menuMob || !Array.isArray(this.menuMob)) return []
            let out_menu_first = []
            this.menuMob.forEach(item => {
                if(item.label && item.to) {
                    out_menu_first.push({
                        label: {
                            ru: item.label || null,
                            en: item.label || null
                        },
                        href: item.to,
                        btnIcon: 'pi pi-angle-right',
                    })
                }
            })
            return out_menu_first
        }
    },
    watch: {
        mob_menu: function (val) {
            document.body.classList = val ? 'overflow-hidden' : ''
        },
        isDarkTheme: function (val) {
            this.themeMode = val
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
    },
    mounted(){
        if(this.isDarkTheme) this.themeMode = true
        else this.themeMode = false
    }
}
</script>